window.videoPlayer = () => {
    return {
        paused: true,
        videoPlayer: null,
        isYoutube: false,
        isVimeo: false,

        init() {
            this.videoPlayer = this.$el.querySelector('video');

            if (this.videoPlayer !== null && typeof this.videoPlayer !== 'undefined') {
                this.videoPlayer.addEventListener('play', () => {
                    this.paused = false;
                });

                this.videoPlayer.addEventListener('pause', () => {
                    this.paused = true;
                });

                this.videoPlayer.addEventListener('ended', () => {
                    this.paused = true;
                });
            }

            if (typeof this.$el.querySelectorAll('.video-embed') !== "undefined" && this.$el.querySelectorAll('.video-embed') !== null && this.$el.querySelectorAll('.video-embed').length) {
                const iframe = this.$el.querySelector('.video-embed iframe');
                if (iframe.src.includes('vimeo')) {
                    this.isVimeo = true;
                } else {
                    this.isYoutube = true;
                }
            }
        },

        playVideo() {
            this.paused = false;

            if (this.isYoutube) {
                const iframe = this.$root.querySelector('.video-embed iframe');
                const currentSrc = iframe.src;
                const videoID = this.extractYouTubeVideoID(currentSrc);
                
                // Update the src URL with autoplay, loop, and playlist
                const newSrc = `${currentSrc.split('?')[0]}?autoplay=1&loop=1&playlist=${videoID}&controls=0`;

                // Set the new source URL with the loop parameters
                iframe.src = newSrc;
            } else if (this.isVimeo) {
                this.playVimeo(this.$root.querySelector('.video-embed iframe'));
            } else {
                const video = this.$root.querySelectorAll('video')[0];
                video.play();
            }
        },

        playVimeo(el) {
            this.paused = false;
            const player = new Vimeo.Player(el);
            player.play();
            // Set player options for controls visibility
            player.setVolume(0);
            player.setControls(false);
        },

        pauseVimeo(el) {
            this.paused = true;
            const player = new Vimeo.Player(el);
            player.pause();
        },

        // Helper function to extract YouTube video ID
        extractYouTubeVideoID(url) {
            const regex = /[\\?\\&]v=([^\\?\\&]+)/;
            const matches = url.match(regex);
            return matches ? matches[1] : null;
        }
    }
}
